/**
 * Live metrics display during a typing test.
 * Uses aria-live="polite" so screen readers announce changes without
 * interrupting the user's typing.
 *
 * @param {{
 *   grossWpm: number,
 *   netWpm: number,
 *   accuracy: number,
 *   remainingSeconds: number,
 *   progress: number,
 * }} props
 */
export function MetricsBar({ grossWpm, netWpm, accuracy, remainingSeconds, progress }) {
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2" aria-live="polite">
      <div className="flex items-baseline gap-1">
        <span className="text-2xl font-bold tabular-nums text-text-primary">
          {Math.round(netWpm)}
        </span>
        <span className="text-xs text-text-muted">net WPM</span>
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-lg font-semibold tabular-nums text-text-secondary">
          {Math.round(grossWpm)}
        </span>
        <span className="text-xs text-text-muted">gross</span>
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-lg font-semibold tabular-nums text-success">
          {Math.round(accuracy)}%
        </span>
        <span className="text-xs text-text-muted">accuracy</span>
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-lg font-semibold tabular-nums text-text-primary">
          {remainingSeconds}s
        </span>
        <span className="text-xs text-text-muted">left</span>
      </div>
      <div
        className="h-1.5 w-24 overflow-hidden rounded-full bg-surface-sunken"
        role="progressbar"
        aria-valuenow={Math.round(progress * 100)}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Passage progress"
      >
        <div
          className="h-full rounded-full bg-brand-500 transition-[width] duration-150"
          style={{ width: `${Math.round(progress * 100)}%` }}
        />
      </div>
    </div>
  );
}